<div class="px-px-24 py-px-16">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-px-16">
    <div>
      <div class="fs-20 fw-7">Journal d'audit</div>
      <div class="fs-13 text-neutral-dark-grey">Connexions, gestion des collaborateurs, paramètres et missions.</div>
    </div>
    <div class="audit-filter">
      <mat-label class="fs-13">Filtrer par action</mat-label>
      <mat-select [(ngModel)]="selectedAction" (selectionChange)="onActionChange()" placeholder="Toutes les actions">
        <mat-option [value]="null">Toutes les actions</mat-option>
        @for (action of actions; track action.value) {
          <mat-option [value]="action.value">{{ action.label }}</mat-option>
        }
      </mat-select>
    </div>
  </div>

  @if (loading) {
    <app-loader></app-loader>
  } @else {
    <div class="audit-table-wrapper">
      <table class="audit-table">
        <thead>
          <tr>
            <th style="width: 15%">Date</th>
            <th style="width: 22%">Collaborateur</th>
            <th style="width: 20%">Action</th>
            <th>Détails</th>
          </tr>
        </thead>
        <tbody>
          @for (entry of entries; track entry.id) {
            <tr>
              <td data-label="Date">{{ format(entry.createdAt) }}</td>
              <td data-label="Collaborateur">
                <div>
                  <div class="fw-6">{{ entry.actorName || entry.actorEmail || '—' }}</div>
                  <div class="fs-12 text-neutral-dark-grey" *ngIf="entry.actorName && entry.actorEmail">{{ entry.actorEmail }}</div>
                </div>
              </td>
              <td data-label="Action"><span class="action-badge">{{ entry.actionLabel }}</span></td>
              <td class="details" data-label="Détails">{{ entry.details }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="4" class="empty">Aucune entrée pour le moment.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <mat-paginator
    [length]="totalElements"
    [pageIndex]="page"
    [pageSize]="size"
    [pageSizeOptions]="[20, 50, 100]"
    (page)="onPage($event)"
    [showFirstLastButtons]="true"
  ></mat-paginator>
</div>
